import React, {Component} from 'react';
import {Icon} from 'antd';

class Preloader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: null,
			strings: this.props.language
		}
	}

	componentWillReceiveProps() {
		const comp = this;
		setTimeout(function() {
			const lang = comp.props.language;
			comp.setState({strings: lang});
		}, 100)
	}

	render() {
		//const {strings} = this.state;
		return (
			<div className={this.props.preloader? null: 'd-none'}>
				<div className="preloader">
					<Icon type="loading"/>
					<p className="d-none" data-translationkey="preflightingTxt" >{this.props.preflightingTxt}</p>
				</div>
			</div>
		);
	}
}

export default Preloader;


// WEBPACK FOOTER //
// ./src/components/Preloader.js